export default {
  api: [],
  page: [{ rule: "settings/singlesignon", allow: true }],
};
